import { render } from "./EditFrontOffice.vue?vue&type=template&id=81a51320&scoped=true"
import script from "./EditFrontOffice.vue?vue&type=script&lang=js"
export * from "./EditFrontOffice.vue?vue&type=script&lang=js"

import "./EditFrontOffice.vue?vue&type=style&index=0&id=81a51320&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-81a51320"

export default script